import React, { useState, useEffect } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import MaterialTypography from "../../components/MaterialTypography";
import {
  Autocomplete,
  Card,
  CardHeader,
  Grid2,
  Stack,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import MaterialBox from "../../components/MaterialBox";
import { fetchAll } from "../../ApiBaseUrl";
import useBranchAccess from "../../hooks/useBranchAccess";

const Payroll = () => {
  const navigate = useNavigate();
  const { isBranchAdmin, userBranch } = useBranchAccess();
  const currentYear = new Date().getFullYear();

  const monthOptions = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  const yearOptions = Array.from({ length: 26 }, (_, i) => {
    const year = currentYear - i;
    return {
      value: year,
      label: year,
    };
  });

  //pages
  const [totalCount, setTotalCount] = useState(0);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const [categoriesOptions, setcategoriesOptions] = useState([]);

  const [branchOptions, setbranchOptions] = useState([]);

  const [categories, setcategories] = useState([]);

  const [branches, setbranches] = useState([]);

  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);


  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [employeeSalaryList, setEmployeeSalaryList] = useState([]);

  useEffect(() => {
    if (isBranchAdmin) setbranches([userBranch]);
  }, [isBranchAdmin, userBranch]);

  useEffect(() => {
    if (isBranchAdmin && (!branches || branches.length === 0)) return;
    onSalaryStructureSubmit();
  }, [categories, branches, year, month, paginationModel, isBranchAdmin]);

  useEffect(() => {
    const fetchBranches = async () => {
      // setCirleLoading(true);
      try {
        const fields = [
          "id",
          "name",
          "description",
          "address",
          "state",
          "zipCode",
          "branchIncharge",
        ];
        const data = await fetchAll("Branch", fields);
        let result = data?.allBranch;
        let filterdata = result.map((val) => {
          return {
            value: val.id,
            label: val.name,
          };
        });
        setbranchOptions(filterdata);
      } catch (error) {
        console.error("Error fetching branches:", error);
      } finally {
        // setCirleLoading(false);
      }
    };

    fetchBranches();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.post(BASEURL, {
          query: `query { allCategories }`,
        });
        const categoriesList = response?.data?.data?.allCategories || [];
        const options = categoriesList.map((cat) => ({
          value: cat,
          label: cat,
        }));
        setcategoriesOptions(options);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const SalaryStructureListTable = {
    columns: [
      {
        field: "year",
        headerName: "Year",
        flex: 1,

        sortable: true,
      },
      {
        field: "months",
        headerName: "Month",
        flex: 1,

        sortable: true,
      },
      {
        field: "category",
        headerName: "Category",
        width: 300,
        sortable: true,
      },

      {
        field: "branch",
        headerName: "Branch",
        width: 300,
        sortable: true,
      },
    ],

    rows: employeeSalaryList.map((manager, index) => ({
      id: index + 1,
      year: manager.year,
      month: manager.month,
      months: monthNames[manager.month - 1],
      category: manager.category,
      branch: manager?.branch,
    })),
  };

  const handleNewSalaryStructure = () => {
    navigate("/payroll/add-payroll");
  };

  const onEmployeeListClick = (e) => {
    if (e?.id) {
      navigate(`/payroll/add-payroll`, { state: { data: e?.row } });
    }
  };

  const onSalaryStructureSubmit = async () => {
    const query = `
      query payrollList(
  $month: [Int]
  $year: [Int]
  $branch: [String]
  $category: [String]
  $page: Int
  $pageSize: Int
  $search: String
) {
  payrollList(
    month: $month
    year: $year
    branch: $branch
    category: $category
    page: $page
    pageSize: $pageSize
    search: $search
  ) {
    success
    message
    data {
      month
      year
      branch
      category
    }
    pagination {
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
}
 
       `;
    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: {
            category: categories,
            month,
            year,
            branch: branches,
            page: paginationModel?.page + 1,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );


      const EmployeeSalaryResponse = response.data.data.payrollList?.data;
      setEmployeeSalaryList(EmployeeSalaryResponse);
      const totalcount = response.data.data.payrollList?.pagination?.totalCount;

      setTotalCount(Number(totalcount));
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  const handlefilter = (event, name) => {
    let state = null;
    if (name == "categories") {
      state = [...categories];
    } else if (name == "branches") {
      state = [...branches];
    } else if (name == "year") {
      state = [...year];
    } else {
      state = [...month];
    }

    const selecteddata = event;

    // categoriesState["categoriesDaysStatus"] =
    // selectedDays.length > 0 ? "success" : "unchecked";

    state = selecteddata.map((day) =>
      name == "month" ? day.value : day.label,
    );
    if (name == "categories") {
      setcategories(state);
    } else if (name == "branches") {
      setbranches(state);
    } else if (name == "year") {
      setYear(state);
    } else {
      setMonth(state);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Payroll List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewSalaryStructure()}
              >
                Run Payroll
              </MaterialButton>
            </Stack>
          }
        />

        <Grid2 size={{ xs: 12, md: 12, lg: 12 }} container spacing={1} p={1}>
          <Grid2 size={{ xs: 12, md: 12, lg: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Categories
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              options={categoriesOptions.filter(
                (option) => !categories?.includes(option.value), // 👈 custom filter
              )}
              value={categories.map((day) => ({
                value: day,
                label: day,
              }))}
              onChange={(event, newValue) =>
                handlefilter(newValue, "categories")
              }
              getOptionLabel={(option) => option.label}
              // disabled={togglePage.view === true}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Choose multiple Categories"
                />
              )}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 12, lg: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Branches
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              disabled={isBranchAdmin}
              options={branchOptions.filter(
                (option) => !branches.includes(option.label), // 👈 custom filter
              )}
              value={branches.map((day) => ({
                value: day,
                label: day,
              }))}
              onChange={(event, newValue) => handlefilter(newValue, "branches")}
              getOptionLabel={(option) => option.label}
              // disabled={togglePage.view === true}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Choose multiple Branches"
                />
              )}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 12, lg: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Year
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              options={yearOptions.filter(
                (option) => !year?.includes(option.value), // 👈 custom filter
              )}
              value={year.map((day) => ({
                value: day,
                label: day,
              }))}
              onChange={(event, newValue) => handlefilter(newValue, "year")}
              getOptionLabel={(option) => option.label}
              // disabled={togglePage.view === true}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Choose multiple Year"
                />
              )}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 12, lg: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Month
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              options={monthOptions.filter(
                (option) => !month?.includes(option.value), // 👈 custom filter
              )}
              value={month.map((m) =>
                monthOptions.find((opt) => opt.value === m),
              )}
              onChange={(event, newValue) => handlefilter(newValue, "month")}
              getOptionLabel={(option) => option.label}
              // disabled={togglePage.view === true}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Choose multiple Month"
                />
              )}
            />
          </Grid2>
        </Grid2>
        <MaterialDataGrid
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          rowCount={totalCount}
          rows={SalaryStructureListTable.rows}
          columns={SalaryStructureListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          // sortModel={[{ field: 'id', sort: 'desc' }]}
          onRowClick={onEmployeeListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No payroll found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any payroll details. Click on the "Run
                  Payroll" button to start adding payroll.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default Payroll;
